import { generalActions as actions } from './generalActions';
import { generalReducer as reducer } from './generalReducer';
import { generalSelectors as selectors } from './generalSelectors';

export const general = {
  actions,
  reducer,
  selectors,
};
